import { render, staticRenderFns } from "./Ships.vue?vue&type=template&id=0d3f3b0a&scoped=true"
import script from "./Ships.vue?vue&type=script&lang=ts"
export * from "./Ships.vue?vue&type=script&lang=ts"
import style0 from "./Ships.vue?vue&type=style&index=0&id=0d3f3b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3f3b0a",
  null
  
)

export default component.exports